"use client";

import { useState } from "react";
import Icon from "./icon";

function ShareButtons(props: {
  title: string;
  url: string;
  summary?: string;
  shareText?: string;
}) {
  const title = props.title;
  const summary = props.summary || "";
  const url =
    props.url || (typeof window !== "undefined" ? window.location.href : "");
  const [copied, setCopied] = useState(false);

  const handleShare = async () => {
    const shareData = {
      url: url,
    };
    const isMobile = typeof window !== "undefined" && window.innerWidth < 700;
    if (navigator.share && isMobile) {
      try {
        await navigator.share(shareData);
      } catch (err) {
        console.warn("Delning avbröts eller misslyckades:", err);
      }
    } else if (navigator.clipboard) {
      try {
        await navigator.clipboard.writeText(shareData.url);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      } catch (err) {
        console.error("Kunde inte kopiera länken:", err);
      }
    } else {
      console.error("Delning stöds inte på denna enhet.");
    }
  };

  if (!props.url) return null;

  return (
    <div className="relative inline-flex">
      <button
        aria-label="Dela artikel"
        className="btn p-0 rounded-sm hover:bg-sand-800 ml-auto bg-sand-700"
        onClick={handleShare}
      >
        <span className="h-full bg-sand-800 py-2 px-2 rounded-sm md:rounded-none md:rounded-l-sm">
          <Icon.Share className="size-[18px] fill-black-500 text-black-500" />
        </span>
        <span className="hidden md:block px-2">
          {copied ? "Länk kopierad" : "Dela"}
        </span>
      </button>
    </div>
  );
}

export default ShareButtons;
